/**
 * Format a number with locale-aware separators.
 */
export function formatNumber(value: number, locale = "en-US"): string {
  return new Intl.NumberFormat(locale).format(value);
}

/**
 * Get user initials from first and last name.
 * Pass singleLetter=true for one-character avatars (ACL design).
 * Names are typed as required but several sources (auth profile, proposals,
 * ACL) can hand back null/empty at runtime — never throw, just fall back to "".
 */
export function getInitials(
  firstName?: string | null,
  lastName?: string | null,
  singleLetter = false,
): string {
  const first = firstName?.charAt(0) ?? "";
  if (singleLetter) return first.toUpperCase();
  const last = lastName?.charAt(0) ?? "";
  return `${first}${last}`.toUpperCase();
}

export { formatRole, formatRoleLabel } from "./acl";

/**
 * Get full name from user parts.
 */
export function getFullName(firstName: string, lastName: string): string {
  return [firstName, lastName].map((p) => p.trim()).filter(Boolean).join(" ");
}

/**
 * Capitalize first letter of each word.
 */
export function capitalize(str: string): string {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

/**
 * Truncate text with ellipsis.
 */
export function truncate(str: string, maxLength: number): string {
  if (str.length <= maxLength) return str;
  return `${str.slice(0, maxLength - 3)}...`;
}
